import blogHd from "../../assets/images/Our Blogs.png";

const HeroHeader = () => {
  return (
    <section id="blogPageHero">
      <div className="wrapper">
        <div className="blog-hero">
          <h5 className="script">
            <img src={blogHd} alt="Made in Love" className="scriptImg" />
          </h5>
          <h2 className="blog-hd">From the Grill to You</h2>
          <p className="blog-para">Stories, tips, and updates from the heart of Mains</p>
        </div>
      </div>
    </section>
  );
};

export default HeroHeader;
